__turbopack_context__.v({
  "active": "Dot-module__J3f_mW__active",
  "dot": "Dot-module__J3f_mW__dot",
});
